import { View, Image, Text } from '@react-pdf/renderer';
import { Badge, Span } from '..';
import { DocumentState, Supplier } from '../../../common';
import { en } from '../../theme/languages/en';
import { styles } from './Header.module';

interface HeaderProps {
  supplier: Supplier;
  documentState: DocumentState;
}

export const Header = ({ supplier, documentState }: HeaderProps) => {
  return (
    <View style={styles.container} fixed>
      {/* logo */}
      {supplier?.iconData ? (
        <View style={[styles.logoWrapper, styles.flexCenter]}>
          <Image style={styles.logo} src={supplier?.iconData} />
        </View>
      ) : (
        <View style={[styles.logoPlaceholder, styles.flexCenter]}>
          <Span style={styles.logoLabel}>{en.attachYourLogo}</Span>
        </View>
      )}
      <View
        style={[
          styles.flexColumn,
          styles.flexEnd,
          {
            maxWidth: 300,
          },
        ]}
      >
        <Badge documentState={documentState} />
        <Span style={styles.text}>{supplier?.legalName}</Span>
        <Text style={[styles.text, { marginTop: 5 }]}>{supplier?.email}</Text>
      </View>
    </View>
  );
};
